import Vue from 'vue';

// 注册一个全局自定义指令 v-lx-click
Vue.directive('lx-click', {
  // 当绑定元素插入到 DOM 中。
  inserted: function (el, binding) {
    el.onclick = function (el) {
      let value = binding.value;
      LXAnalytics && LXAnalytics('moduleClick', value);
    };
  }
});



// WEBPACK FOOTER //
// ./src/components/core/registerDirective.js